<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm12 md6>
              <v-text-field
                label="Document Name *"
                v-model="formSchema.document_name"
                :rules="[v => !!v || 'Document name is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              Upload Document
              <input
                type="file"
                id="files2"
                ref="image2"
                v-on:change="handleFilesUpload()"
              />
            </v-flex>

            <!-- <v-flex xs12 sm6 md4>
              <v-text-field
                label="Record ID"
                v-model="formSchema.record_id"
                :rules="[v => !!v || 'Record id is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="Sub Menu"
                v-model="formSchema.sub_menu_id"
                :rules="[v => !!v || 'Sub menu is required !']"
                required
              ></v-text-field>
            </v-flex>-->

            <v-flex xs12 sm6 md4>
              <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
          
          <v-btn color="error" @click="previous">
            <v-icon>arrow_back_ios</v-icon>Previous
          </v-btn>

          <template v-if="loan_id>0">
          <!-- v-if="total_disburs<1 && saveBtn < 2" -->
          <v-btn v-if="saveBtn < 2" color="success" @click="checkFormValidation">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn v-if="total_disburs<1" color="secondary" @click.native="reset">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
          </template>

          <v-btn color="primary" @click="nextStep">
            Nexts
            <v-icon>arrow_forward_ios</v-icon>
          </v-btn>
      </v-card-actions>
    </v-form>    

    <v-card class="mb-3 mt-3" color="lighten-1">
      <table border="1" class="partner_tbl">
        <tr>
          <th>SL</th>
          <th>Document Name</th>
          <th>Status</th>
          <th>Active</th>
          <th>Action</th>
        </tr>
        <tr v-for="(val,index) in dataList" :key="index">
          <td>{{index+1}}</td>
          <td>{{val.document_name}}</td>
          <td>
            <span v-if="val.is_active" class="active">Yes</span>
            <span v-else class="in-active">No</span>
          </td>
          <td>
            <a
              target="_blank"
              v-if="val.document_file_name"
              title="Download"
              :href="`${public_path}${val.document_file_name}`"
              download
            >
              <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>
            </a>
          </td>
          <td>         
            <template v-if="saveBtn < 2">
            <v-btn icon class="mx-0" @click="editItem(index, val)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="deleteItem(index, val.id)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            </template>
            <template v-else>
              <br><br>
            </template>
          </td>
        </tr>
      </table>
    </v-card>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
let UtilService = require("../../../../services/util.service");
import ServerPath from "../../../../server-path/server-path";

export default {
  data() {
    return {
      valid: true,
      loan_id:0,

      e1: 0,
      saveBtn:0,
      
      operation_act_id: UtilService.getProjectId(),
      is_activeVal: 1,
      revision:null,
      total_disburs:0,

      rules: {
        decimalOnly: value => {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Not a valied number";
        }
      },
      public_path: "",

      delete_id: "",
      row_index: "",
      dialog2: false,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      formSchema: {
        id: 0,
        operation_act_id: UtilService.getProjectId(),
        document_name: "",
        record_id: "",
        sub_menu_id: "",
        is_active: ""
      },
      documentFiles: [],
      dataList: []
    };
  },

  computed: {
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    this.total_disburs = this.$store.getters.GET_KEY_VALUE;

    this.loan_id = sessionStorage.getItem("loan_id");    
    this.revision = sessionStorage.getItem("revision");    
    this.public_path = ServerPath.serverPath;

      let lPstatus = sessionStorage.getItem("loan_s");
      if(lPstatus)
      {
        this.saveBtn = atob(lPstatus);
        //console.log('this.saveBtn', this.saveBtn);
      }

      this.loadData();
  },

  methods: {
    loadData() {
      let loan_id = sessionStorage.getItem("loan_id");
      let mulParam = {
        record_id : sessionStorage.getItem("mm_id"),
        sub_menu_id : sessionStorage.getItem("sm_id"),
        master_table_id : loan_id,
      };
      if(loan_id > 0)
      {
        commonService .dataByMulParameters(mulParam,"project-document-list"
          ).then(res => {
            if (Array.isArray(res.data) && (res.data.length > 0)) {
                this.dataList = res.data;
                this.saveBtn = res.msTable.status
            }
          });
      }
    },

    checkFormValidation() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      this.$refs.loader.loaderEnabled();

      let formSchema = this.formSchema;
      formSchema.operation_act_id =  UtilService.getProjectId();      
      formSchema.record_id = sessionStorage.getItem("mm_id");
      formSchema.sub_menu_id = sessionStorage.getItem("sm_id");
      formSchema.revision = (this.revision>0) ? this.revision : null;
      formSchema.master_table_name = 'lending_loan_profiles';
      formSchema.master_table_id = sessionStorage.getItem("loan_id");

      let uploadedFiles = this.$refs.image2.files;
      if (formSchema.id < 1 && uploadedFiles.length == 0) {
       
        this.SnackbarVal.message = "Upload File is empty!";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";

        return false;
      }

      let formData = new FormData();

      for (var i = 0; i < this.documentFiles.length; i++) {
        let file = this.documentFiles[i];
        formData.append("files[" + i + "]", file);
      }

      formData.append("dataList", JSON.stringify(formSchema));

      commonService.insertFormData(formData, "project-document").then(res => {  

        if (res.status == 1) {
          this.documentFiles = [];

          if (res.action == "edit") {
            this.$set(this.dataList, this.row_index, { ...res.data });
          }
          else 
          {                    
            this.dataList.unshift({ ...res.data });  
            //this.nextStep();                      
          }

          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "success";

          document.getElementById("files2").value = null;
          this.formSchema.id = 0;  
          this.close();
        }
      });
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);
      
      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.PDF|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {

        this.SnackbarVal.message = "You can upload jpg, jpeg, png, pdf and docx file only";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";

        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        //console.log("uploadedFiles[i] = ", uploadedFiles[0]);

        this.documentFiles = uploadedFiles;

        // for (var i = 0; i < uploadedFiles.length; i++) {
        //   this.documentFiles.push(uploadedFiles[i]);
        // }
      }
    },

    nextStep() {
      let loan_id = sessionStorage.getItem("loan_id");
      let reset_no = sessionStorage.getItem("reset_no");
      let re_schedule_no = sessionStorage.getItem("re_schedule_no");

      if(reset_no < 1 && re_schedule_no < 1)
      {
        commonService.getAllDataById(loan_id, "check-disbursment-by-lona-id").then(res => {
          //console.log('dddddddd',res);
          if(res.count>0)
          {
            this.$emit("emitForm2", 3);
          }
          else
          {
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;
            this.SnackbarVal.color = "error";
            return false;
          }
        })
      }
      else
      {
        this.$emit("emitForm2", 3);
      }
    },

    previous() {
      this.$emit("emitForm2", 1);
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = {...item};
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "project-document").then(res => {
        if (res.status == 1) {
          this.dataList.splice(row_index, 1);
          this.documentFiles = [];
          this.SnackbarVal.color = "success";
        }
        else
        {
          this.SnackbarVal.color = "error";
        }

        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      // let formSchema = this.formSchema;
      // Object.keys(formSchema).forEach(function(key) {
      //   formSchema[key] = "";
      // });       
     this.$refs.form.reset();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/lending/loanProfile/step_forms/projectDocument.vue